import { render, staticRenderFns } from "./ImportChildren.vue?vue&type=template&id=63abfd79&"
import script from "./ImportChildren.vue?vue&type=script&lang=js&"
export * from "./ImportChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports